import React from "react";
import "./style.css";
import { Title } from "../Title";
import Post1 from "./posts/post-01.png";
import Post2 from "./posts/post-02.png";
import Post3 from "./posts/post-03.png";
import Post4 from "./posts/post-04.png";
import Post5 from "./posts/post-05.png";
import Post6 from "./posts/post-06.png";
import Post7 from "./posts/post-07.png";
import Post8 from "./posts/post-08.png";
import Post9 from "./posts/post-09.png";

export const Follow = ({ className, content }) => {
  const follow = content.sections.follow;
  const postImages = [
    { src: Post1, link: "#" },
    { src: Post2, link: "#" },
    { src: Post3, link: "#" },
    { src: Post4, link: "#" },
    { src: Post5, link: "#" },
    { src: Post6, link: "#" },
    { src: Post7, link: "#" },
    { src: Post8, link: "#" },
    { src: Post9, link: "#" },
  ];
  return (
    <section
      id="follow"
      className={`follow ${className} position-relative detail-top detail-bottom`}
    >
      <div className="container">
        <Title
          title={follow.title}
          description={follow.description}
        />
        <div className="row">
          <div className="col-xl-5 col-12">
            <div className="follow-header d-flex flex-wrap align-items-center justify-content-between">
              <div className="follow-header-numbers d-flex align-items-center justify-content-between">
                <div className="follow-header-number__item">
                  <strong className="d-block">29</strong>
                  <small className="d-block">{follow.posts}</small>
                </div>
                <div className="follow-header-number__item">
                  <strong className="d-block">107</strong>
                  <small className="d-block">{follow.followers}</small>
                </div>
              </div>
              <div className="follow-box-button">
                <button className="d-flex align-items-center w-100">
                  <svg
                    width="23"
                    height="23"
                    viewBox="0 0 23 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.709 1H6.8836C3.63417 1 1 3.63417 1 6.8836V15.709C1 18.9584 3.63417 21.5926 6.8836 21.5926H15.709C18.9584 21.5926 21.5926 18.9584 21.5926 15.709V6.8836C21.5926 3.63417 18.9584 1 15.709 1Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2965 15.7092C8.85935 15.7092 6.88379 13.7336 6.88379 11.2965C6.88379 8.85935 8.85935 6.88379 11.2965 6.88379C13.7336 6.88379 15.7092 8.85935 15.7092 11.2965C15.7092 12.4667 15.2442 13.5892 14.4167 14.4167C13.5892 15.2442 12.4667 15.7092 11.2965 15.7092Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="16.9592"
                      cy="5.63331"
                      r="1"
                      stroke="white"
                      stroke-width="1.08889"
                    />
                  </svg>
                  {follow.button} <strong>the instantors</strong>
                </button>
              </div>
            </div>
            <div className="follow-posts row">
              {postImages.map((item, index) => (
                <div className="post__item col-4" key={index}>
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <img
                      src={item.src}
                      alt="Post Instagram"
                      className="img-fluid w-100"
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="col-xl-7 col-12">
            <iframe
              title="Instagram feed"
              dataTestid="embed-iframe"
              src="https://open.spotify.com/embed/album/0RySAmM6oDPGSE03X3dzi1?utm_source=generator&theme=0"
              width="100%"
              height="650"
              frameBorder="0"
              allowfullscreen=""
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};
